import styled from "@emotion/styled";

export const Container = styled.div`
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    li {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      border-bottom: 1px solid #eee;
      padding: 5px;
      img {
        width: 80px;
        height: 60px;
        object-fit: cover;
      }

      > div {
        margin-right: 10px;
      }
      > span {
        flex: 1;
      }
      > i {
        cursor: pointer;
        color: red;
      }
    }
  }
`;
